import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'wonderbly-components/lib/Button';
import CanvasDrawerContent from './CanvasDrawerContent';
import CanvasDrawerLabel from './CanvasDrawerLabel';

import './CanvasDrawers.scss';
import SaveForLater from '../SaveForLater';

// Some drawers rely on the product form's content to work correctly.
const drawersThatNeedProductForm = ['adventurer', 'multi_adventurer', 'multi_birthday'];

const CanvasDrawers = props => (
  <div className="canvas-drawers-hold">
    <div
      className={cx('canvas-drawers', {
        'canvas-drawers-fixed': props.isFixed,
      })}>
      <div className="canvas-drawers-content-wrap">
        {props.drawers.other.map((drawer, index) => (
          <CanvasDrawerContent
            key={`${drawer.sliceType}-${index}`}
            index={index}
            activeDrawer={props.activeDrawer}
            title={drawer.primary.title}
            description={drawer.primary.description}
            prismicProduct={props.prismicProduct}
            onToggleDrawer={props.handleToggleDrawer}
            completedDrawersMap={props.completedDrawersMap}
            drawer={drawer}
            form={drawersThatNeedProductForm.includes(drawer.sliceType) && props.drawers.form}
          />
        ))}
      </div>
      <div className="canvas-drawers-wrap">
        <div className="container expanded canvas-drawers-wrap-container">
          <div className="canvas-drawers-label-wrapper display-none-if-no-js">
            {props.drawers.other.map((drawer, index) => (
              <CanvasDrawerLabel
                key={`${drawer.sliceType}-${index}`}
                index={index}
                prismicProduct={props.prismicProduct}
                activeDrawer={props.activeDrawer}
                onToggleDrawer={props.handleToggleDrawer}
                drawer={drawer}
                completedDrawers={props.completedDrawersMap.complete}
              />
            ))}
          </div>
          <div
            className={cx('canvas-drawers-button', {
              'canvas-drawers-button--loading': props.cartPending,
            })}>
            {props.isAllDrawersComplete
              ? (
                <Button
                  colour="green"
                  onClick={props.onSubmitDrawers}
                  disabled={props.cartPending}
                  raised>
                  {props.completedText}
                </Button>
              )
              : (
                <Button
                  onClick={props.onContinueDrawers}
                  outlined={!props.activeDrawer}
                  disabled={!!props.activeDrawer}>
                  {props.continueText}
                </Button>
              )}
            {props.showSaveForLaterButton &&
              <SaveForLater
                data={props.saveForLaterData}
                errorMessages={props.errorMessages}
                canonicalUrl={props.canonicalUrl}
                productId={props.productId}
                locale={props.locale}
                ctaStyle={props.saveForLateCtaStyle}
                ctaBackgroundColor={props.saveForLaterCtaBackgroundColor}
                ctaIcon={props.saveForLaterCtaIcon}
                ctaIconGlobalContent={props.saveForLaterCtaIconGlobalContent}
                ctaTextGlobalContent={props.saveForLaterCtaTextGlobalContent}
                adventurersNames={props.adventurersNames}
              />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
);

CanvasDrawers.propTypes = {
  isFixed: PropTypes.bool,
  completedDrawersMap: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.string.isRequired),
    complete: PropTypes.arrayOf(PropTypes.string.isRequired),
    incomplete: PropTypes.arrayOf(PropTypes.string.isRequired),
  }),
  drawers: PropTypes.shape({
    form: PropTypes.object,
    other: PropTypes.arrayOf(
      PropTypes.shape({
        sliceType: PropTypes.string.isRequired,
        primary: PropTypes.shape({
          title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
          ]).isRequired,
          description: PropTypes.array,
          tabDefaultText: PropTypes.string,
          tabCompleteTitle: PropTypes.string,
          tabSubtitle: PropTypes.string,
        }),
      }),
    ),
  }),
  activeDrawer: PropTypes.string,
  isAllDrawersComplete: PropTypes.bool.isRequired,
  handleToggleDrawer: PropTypes.func.isRequired,
  onContinueDrawers: PropTypes.func.isRequired,
  onSubmitDrawers: PropTypes.func.isRequired,
  cartPending: PropTypes.bool.isRequired,
  completedText: PropTypes.string.isRequired,
  continueText: PropTypes.string.isRequired,
  prismicProduct: PropTypes.object,
  showSaveForLaterButton: PropTypes.bool,
  saveForLaterData: PropTypes.object,
  saveForLaterCtaIcon: PropTypes.string,
  saveForLaterCtaText: PropTypes.string,
  errorMessages: PropTypes.object,
  saveForLaterCtaIconGlobalContent: PropTypes.string,
  saveForLaterCtaTextGlobalContent: PropTypes.string,
  saveForLateCtaStyle: PropTypes.string,
  saveForLaterCtaBackgroundColor: PropTypes.string,
  saveForLaterCtaTextColor: PropTypes.string,
  canonicalUrl: PropTypes.string,
  productId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  adventurersNames: PropTypes.array,
};

export default CanvasDrawers;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CanvasDrawers/CanvasDrawers.js